import ApplicationController from '../frontend/controllers/application_controller';
import { Janus } from 'janus-gateway';


export default class extends ApplicationController {
    static remoteFeeds = {};
    pvtid = null;
    isMyStream = null;
    janusId = null;
    videoElementID = null;
    videoElement = null;
    scheduledSessionId = null;
    contactId = null;

    initialize() {

    }

    connect() {
        super.connect();
        this.pvtid = sessionStorage.getItem('pvtid');
        this.scheduledSessionId = this.element.getAttribute('data-scheduled_session_id');
        this.contactId = this.element.getAttribute('data-contact_id');
        this.isMyStream = this.element.getAttribute('data-mystream');
        this.janusId = this.element.getAttribute('data-janus_id');
        this.isScreenshare = this.element.getAttribute('data-is_screenshare') === 'true';
        this.simulationMode = this.element.getAttribute('data-simulation_mode') === 'true';
        this.videoElementID = "remotevideo-" + this.janusId;
        this.videoElement = this.element.querySelector(`#${this.videoElementID}`);

        // Skip video connection in simulation mode
        if (this.simulationMode) {
            console.debug("Simulation mode: skipping video connection");
            return;
        }

        // if this video card is my stream, connect to local stream
        if (this.isMyStream == "true") {
            this.connectLocalStream();
            // The local stream can be swapped mid-call (background blur falling
            // back to the plain camera); removed in disconnect
            this.boundHandleLocalStreamChanged = () => this.connectLocalStream();
            document.addEventListener('localVideoStreamChanged', this.boundHandleLocalStreamChanged);
        } else {
            // otherwise connect to the remote stream
            this.connectRemoteStream();
            // listen for the remoteStreamAdded event (removed in disconnect)
            this.boundHandleRemoteStreamAdded = this.handleRemoteStreamAdded.bind(this);
            document.addEventListener('remoteStreamAdded', this.boundHandleRemoteStreamAdded);
        }

        // Listen for morphs to reconnect video when element reappears
        this.boundHandleMorph = this.handleMorph.bind(this);
        document.addEventListener('stimulus-reflex:after', this.boundHandleMorph);
        document.addEventListener('cable-ready:after-morph', this.boundHandleMorph);
    }

    
    
    //adds padding for portait videos
    adjustAspectRatio() {
        const video = this.videoElement;
        const videoContainer = this.element;

        const checkVideoSize = () => {
            if (video.videoWidth && video.videoHeight) {
                const containerAspectRatio = videoContainer.clientWidth / videoContainer.clientHeight;
                const videoAspectRatio = video.videoWidth / video.videoHeight;
                if (videoAspectRatio > 1 && !this.isScreenshare) {
                    // Video is wider than the container
                    console.debug("Video is wider than the container, no padding required.");
                    video.style = 'object-fit: cover; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: black; border-radius: 0.75rem !important';
                } else {
                    // Video is taller than the container
                    console.debug("Video is taller than the container, adding padding.");
                    video.style = 'object-fit: contain; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: black; border-radius: 0.75rem !important';
                }
            } else {
                setTimeout(checkVideoSize, 100);
            }
        };

        checkVideoSize();
      }

    connectLocalStream() {
        const startTime = Date.now();

        const waitForLocalVideoStream = () => {
            if (!this.videoElement) {
                // Video element not found, retry
                if (Date.now() - startTime < 10000) {
                    setTimeout(waitForLocalVideoStream, 100);
                }
                return;
            }

            if (window.localVideoStream) {
                if (this.videoElement.srcObject !== window.localVideoStream) {
                    this.element.classList.add('crt-turn-on');
                    this.videoElement.srcObject = window.localVideoStream;
                    this.adjustAspectRatio();

                    window.localVideoStream.getTracks().forEach(track => {
                        track.onended = () => this.handleStreamEnded(this.videoElementID);
                    });
                }
            } else if (Date.now() - startTime < 10000) {
                setTimeout(waitForLocalVideoStream, 100);
            } else {
                console.error("Timeout: Unable to connect to local video stream after 10 seconds.");
            }
        };

        waitForLocalVideoStream();
    }

    connectRemoteStream() {
        if (!this.videoElement) {
            return;
        }

        if (window.remoteStreams && window.remoteStreams[this.contactId] && this.videoElement.srcObject !== window.remoteStreams[this.contactId]) {
            //this.element.classList.add('crt-turn-on');
            this.videoElement.srcObject = window.remoteStreams[this.contactId];
            this.adjustAspectRatio();
            window.remoteStreams[this.contactId].getTracks().forEach(track => {
                // addEventListener, not onended: the sharer's own screen track is
                // shared with ScreenshareConnection, which has its own listener
                track.addEventListener('ended', () => this.handleStreamEnded(this.videoElementID));
            });
        }
    }

    handleRemoteStreamAdded(event) {
        const remoteContactId = event.detail.remoteContactId;
        if (remoteContactId === this.contactId) {
            this.connectRemoteStream();
        }
    }

    handleStreamEnded(elementId) {
        if (this.element) {
            this.element.classList.add('crt-turn-off');
        }
    }

    disconnect() {
        if (this.boundHandleLocalStreamChanged) {
            document.removeEventListener('localVideoStreamChanged', this.boundHandleLocalStreamChanged);
        }
        if (this.boundHandleRemoteStreamAdded) {
            document.removeEventListener('remoteStreamAdded', this.boundHandleRemoteStreamAdded);
        }
        if (this.boundHandleMorph) {
            document.removeEventListener('stimulus-reflex:after', this.boundHandleMorph);
            document.removeEventListener('cable-ready:after-morph', this.boundHandleMorph);
        }
    }

    // Re-check for video element after morphs (e.g., when placeholder is replaced with video)
    handleMorph() {
        // Skip if in simulation mode
        if (this.simulationMode) {
            return;
        }

        // Re-query the video element in case it was just rendered
        const newVideoElement = this.element.querySelector(`#${this.videoElementID}`);

        // If video element appeared and we don't have a srcObject yet, connect the stream
        if (newVideoElement && !newVideoElement.srcObject) {
            this.videoElement = newVideoElement;
            if (this.isMyStream == "true") {
                this.connectLocalStream();
            } else {
                this.connectRemoteStream();
            }
        }
    }


            
}
